import React from 'react';
import './SecurityLogoCarousel.css';

// Using the correct logo URLs from the website's CDN
const logos = [
  { src: "https://sendbird.imgix.net/cms/Maya.png?auto=format,compress&h=200", alt: "Maya" },
  { src: "https://sendbird.imgix.net/cms/Docplanner_2025-04-10-080450_gluk.png?auto=format,compress&h=200", alt: "Docplanner" },
  { src: "https://sendbird.imgix.net/cms/Hyundai_2025-04-10-080451_uqww.png?auto=format,compress&h=200", alt: "Hyundai" },
  { src: "https://sendbird.imgix.net/cms/Hinge_2025-04-10-080451_woxi.png?auto=format,compress&h=200", alt: "Hinge" },
  { src: "https://sendbird.imgix.net/cms/SK-telecom.png?auto=format,compress&h=200", alt: "SK Telecom" },
  { src: "https://sendbird.imgix.net/cms/Virgin-mobile_2025-04-10-080453_pdow.png?auto=format,compress&h=200", alt: "Virgin Mobile" },
  { src: "https://sendbird.imgix.net/cms/WeightWatchers.png?auto=format,compress&h=200", alt: "WeightWatchers" },
  { src: "https://sendbird.imgix.net/cms/WEF.png?auto=format,compress&h=200", alt: "World Economic Forum" },
];

function SecurityLogoCarousel() {
  // We duplicate the logos array to create the seamless scrolling effect
  const extendedLogos = [...logos, ...logos];

  return (
    <section className="security-logo-carousel-wrapper">
      <div className="security-logo-marquee">
        <div className="security-logo-track">
          {extendedLogos.map((logo, index) => (
            <div className="security-logo-item" key={index}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SecurityLogoCarousel;